import Login from "./component/Login";
import Admin from "./component/Admin";
import RecogResultDetailPage from "./component/RecogResultDetailPage";

const AppRoutes = [
    {
        index: true,
        element: <Admin />
    },
    {
        path: '/login',
        element: <Login />
    },
    {
        path: '/result/:jobno',
        element: <RecogResultDetailPage />
    }
];

export default AppRoutes;
